import { render, staticRenderFns } from "./ImageUploadBlock.vue?vue&type=template&id=1085b8f4&scoped=true&"
import script from "./ImageUploadBlock.vue?vue&type=script&lang=ts&"
export * from "./ImageUploadBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUploadBlock.vue?vue&type=style&index=0&id=1085b8f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1085b8f4",
  null
  
)

export default component.exports